import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'
import { State } from 'interfaces/state'
import Login, { LoginStateProps } from 'components/features/pfm/Login/Login'
import { FORM_LOGIN } from 'constants/forms'
import { AnyDict } from 'interfaces'

const selector = formValueSelector(FORM_LOGIN)

const mapStateToProps = (state: State): LoginStateProps => {
  const { deviceUnverified } = state.app.auth
  const deviceFormInitialValues: AnyDict = {
    ...selector(state, 'email', 'password'),
    remember: true,
  }

  return {
    deviceUnverified,
    deviceFormInitialValues,
  }
}

export default connect(mapStateToProps)(Login)
